import * as THREE from "three";
export class Camera extends THREE.PerspectiveCamera {
    constructor() {
        super();
        this.near = 0.1;
        this.far = 4000;
        this.layers.enable(1);
        this.layers.enable(2);
    }
    update(proj, inv) {
        this.position.set(0, 0, 0);
        this.rotation.set(0, 0, 0);
        this.scale.set(1, 1, 1);
        const projMatrix = new THREE.Matrix4();
        projMatrix.fromArray(proj.flat());
        this.projectionMatrix.copy(projMatrix);
        // Add the inverse of the projection matrix
        const projInverted = new THREE.Matrix4();
        projInverted.copy(projMatrix).invert();
        this.projectionMatrixInverse = projInverted;
        const invViewMatrix = new THREE.Matrix4();
        invViewMatrix.fromArray(inv.flat());
        this.applyMatrix4(invViewMatrix);
    }
}
